export enum TalentSearchConnectionType {
  MSG = 'MSG',
  JSP = 'JSP',
  ITA = 'ITA',
  ACCESS_PROFILE = 'ACCESS_PROFILE',
  ACCESS_PROFILE_AND_CV = 'ACCESS_PROFILE_AND_CV',
  ATS_MSG = 'ATS_MSG',
  PROFILE_EXPORT_ATS = 'PROFILE_EXPORT_ATS',
}
